import React, { Component } from 'react'

import { InputGroupAddon, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'

export default class CurrencySelector extends Component {
    state = {
        dropdownOpen: false,
        dropdownDisabled: false,
        direction: 'down'
    }

    componentDidMount() {
        //console.log('curr selector disabled ', this.props.disabled)
        this.setState({
            dropdownDisabled: this.props.disabled || false
        })
    }

    onToggle = () =>
        this.setState(state => ({
            dropdownOpen: !state.dropdownOpen
        }))

    render() {
        const { currency, onChangeCurrency } = this.props
        let currencies = [
            'USD',
            'EUR',
            'PLN',
            'JPY',
            'CNY',
            'SDG',
            'RON',
            'MKD',
            'MXN',
            'CAD',
            'ZAR',
            'AUD',
            'NOK',
            'ILS',
            'ISK',
            'SYP',
            'LYD',
            'UYU',
            'YER',
            'CSD',
            'EEK',
            'THB',
            'IDR',
            'LBP',
            'AED',
            'BOB',
            'QAR',
            'BHD',
            'HNL',
            'HRK',
            'COP',
            'ALL',
            'DKK',
            'MYR',
            'SEK',
            'RSD',
            'BGN',
            'DOP',
            'KRW',
            'LVL',
            'VEF',
            'CZK',
            'TND',
            'KWD',
            'VND',
            'JOD',
            'NZD',
            'PAB',
            'CLP',
            'PEN',
            'GBP',
            'DZD',
            'CHF',
            'RUB',
            'UAH',
            'ARS',
            'SAR',
            'EGP',
            'INR',
            'PYG',
            'TWD',
            'TRY',
            'BAM',
            'OMR',
            'SGD',
            'MAD',
            'BYR',
            'NIO',
            'HKD',
            'LTL',
            'SKK',
            'GTQ',
            'BRL',
            'HUF',
            'IQD',
            'CRC',
            'PHP',
            'SVC'
        ]
        if (this.props.currencies) {
            currencies = this.props.currencies
        }
        return (
            <InputGroupAddon addonType="append">
                <ButtonDropdown direction={this.props.direction} disabled={this.props.disabled} isOpen={this.state.dropdownOpen} toggle={this.onToggle}>
                    <DropdownToggle disabled={this.props.disabled} caret>
                        {currency}
                    </DropdownToggle>
                    <DropdownMenu style={{ maxHeight: '300px', overflow: 'auto', zIndex: '999999 !important' }}>
                        {currencies.map(curr => (
                            <DropdownItem key={curr} onClick={() => onChangeCurrency(curr)}>
                                {curr}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </ButtonDropdown>
            </InputGroupAddon>
        )
    }
}
